import React, { createContext, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Fetch from '../../../../../core/util/core/Fetch';
import config from '../../../../config/config';

const EntityCustomizationContext = createContext(null);

/**
 * Loads the entity customization (name and logo) from /portal/getcustomizations,
 * identified by the friendly_url of the route.
 */
export const EntityCustomizationProvider = ({ children }) => {
    const { friendly_url } = useParams();
    const [state, setState] = useState({ loading: true, error: false, entity: null });

    useEffect(() => {
        let active = true;

        const load = async () => {
            setState({ loading: true, error: false, entity: null });
            try {
                const customData = await Fetch.post(`${config.endpoints.backend}portal/getcustomizations`, {
                    friendly_url,
                    entity: true
                });

                if (!active) return;

                if (customData && customData.entity_name) {
                    setState({
                        loading: false,
                        error: false,
                        entity: {
                            entity_name: customData.entity_name,
                            logo: customData.logo ? config.endpoints.backend + customData.logo : null
                        }
                    });
                } else {
                    setState({ loading: false, error: true, entity: null });
                }
            } catch (e) {
                if (active) setState({ loading: false, error: true, entity: null });
            }
        };

        load();
        return () => {
            active = false;
        };
    }, [friendly_url]);

    return <EntityCustomizationContext.Provider value={state}>{children}</EntityCustomizationContext.Provider>;
};

export const useEntityCustomization = () => useContext(EntityCustomizationContext);
